import { FC } from "react"
import { formInterface } from "@/interface/dataInterface"
import { BaseInput, BaseInputGroup, BaseStaticSelect, BaseTextArea } from "@/components/input/CustomInputs"

const ServiceForm: FC<formInterface> = ({formProp, setFormProp}) => {
    return (
        <div className="grid sm:grid-cols-2 gap-4">
            <BaseInput id="title" label="Name" value={formProp.title} setProp={setFormProp} />
            <BaseInput id="total_cost" label="Price" value={formProp.total_cost} setProp={setFormProp} type="number" placeholder="Enter price value"/>
            <div className="sm:col-span-2">
                <BaseInputGroup id="warranty_period" label="Warranty period" value={formProp.warranty_period} setProp={setFormProp} 
                placeholder="warranty period" type="number" width="w-32 sm:w-40">
                <BaseStaticSelect 
                    id="warranty_unit" 
                    label="" 
                    value={formProp.warranty_unit} 
                    setValue={setFormProp}
                    data={['days', 'weeks', 'months', 'years']}
                />
            </BaseInputGroup>
            </div>
            <div className="sm:col-span-2">
                <BaseTextArea id="notes" label="Notes" value={formProp.notes} setProp={setFormProp} />
            </div>
        </div>
    )
}

export default ServiceForm